/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/age-limit-1237532': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11 7v2a1 1 0 002 0V8h2.78L14 16.8a1 1 0 00.8 1.2h.2a1 1 0 001-.8l2-10a1 1 0 00-.21-.83A1 1 0 0017 6h-5a1 1 0 00-1 1zm7-2h1v1a1 1 0 002 0V5h1a1 1 0 000-2h-1V2a1 1 0 00-2 0v1h-1a1 1 0 000 2zM7 7v10a1 1 0 002 0V7a1 1 0 00-2 0zm14.6 2a1 1 0 00-.78 1.18 9 9 0 11-7-7 1 1 0 10.4-2A10.8 10.8 0 0012 1a11 11 0 1011 11 10.8 10.8 0 00-.22-2.2A1 1 0 0021.6 9z"/>'
  }
})
